import { useTranslation } from 'next-i18next';
export const SouthEastAsiaAward = () => {
  const {
    t
  } = useTranslation(['landing']);
  return <>
      <div className="relative my-md hidden tablet-lg:flex">
        <img src="/assets/award/award-se-asia.webp" alt="SouthEastAsiaAward" className="z-10 h-[308px] rounded-md" />
        <div className="absolute bottom-0 left-0 z-0 ml-xl h-[56px] w-[406px] rounded-l-md bg-gradient-to-r from-yellow-200 to-yellow-50" />
        <div className="pt-lg">
          <div className="flex h-[320px] w-[508px] flex-col items-start justify-center rounded-r-md bg-yellow-50 px-3xl py-xl">
            <GoldTitle data-sentry-element="GoldTitle" data-sentry-source-file="SouthEastAsiaAward.tsx" />
            <span className="mb-sm mt-xs text-body-lg-semibold text-neutral">
              {t('landing.award.southEastAsiaDescription1')}
            </span>
            <span className="text-body-lg-semibold text-neutral">
              {t('landing.award.southEastAsiaDescription2')}
            </span>
          </div>
        </div>
      </div>

      <div className="flex w-full flex-col items-center gap-lg rounded-xl bg-yellow-50 px-md pb-2xl pt-md mobile-lg:w-[500px] tablet-lg:hidden">
        <img src="/assets/award/award-se-asia.webp" alt="SouthEastAsiaAward" className="w-full rounded-md" />
        <div className="flex flex-col items-center gap-xs">
          <GoldTitle data-sentry-element="GoldTitle" data-sentry-source-file="SouthEastAsiaAward.tsx" />
          <span className="text-center text-body-lg-semibold text-neutral">
            {t('landing.award.southEastAsiaDescription1')}
          </span>
        </div>
        <span className="text-center text-body-lg-semibold text-neutral">
          {t('landing.award.southEastAsiaDescription2')}
        </span>
      </div>
    </>;
};
const GoldTitle = () => {
  return <div className="flex items-center gap-xs" data-sentry-component="GoldTitle" data-sentry-source-file="SouthEastAsiaAward.tsx">
      <img src="/assets/award/leaf-left.svg" alt="Left Leaf" />
      <span className="bg-gradient-to-r from-[var(--text-cautionary,#E4A01D)] to-[var(--color-yellow-700,#F1B10B)] bg-clip-text text-heading-xl-extrabold text-transparent">
        Gold Award
      </span>
      <img src="/assets/award/leaf-right.svg" alt="Right Leaf" />
    </div>;
};